import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";

export function getFiles(
    path,
    {ClientID, LocalUserID, forceFetch = false} = {}
) {
    const {_LocalUserID, _ClientID} = getUserApiData({ClientID, LocalUserID});
    return invokeApig({
        ...Paths.getFiles({clientID: _ClientID, localUserID: _LocalUserID}),
        queryParams: {
            Folder: path,
        },
        forceFetch,
    });
}
